export const JIRA_CREATE_ISSUE_MODAL_TEXT = {
  TITLE: 'Create Jira ticket',
  SUBTITLE: 'Select control gaps to create subtasks for in the ticket.',
  PRIMARY_BUTTON_NEXT: 'Next',
  PRIMARY_BUTTON_CREATE: 'Create ticket',
  SECONDARY_BUTTON_BACK: 'Back',
  SECONDARY_BUTTON_PREVIEW: 'Preview',
  HINT: (
    projectKey: string,
    issueTypeName: string,
    subtaskCount: number,
    subtaskTypeName: string,
  ) =>
    `In '${projectKey}' project a '${issueTypeName}' issue will be created with ${subtaskCount} subtasks of type '${subtaskTypeName}'`,
  REQUIRED_FIELDS_HEADING: (issueTypeName: string) => `Required fields for ${issueTypeName}`,
  FIELD_REQUIRED_VALIDATION: (fieldName: string) => `${fieldName} is required`,
  ERROR_ISSUE_TOO_LARGE:
    'The Jira issue is too large. Please reduce the number of controls included in the ticket.',
  ERROR_NO_PERMISSION:
    'You do not have permission to create issues in this project. Please check your Jira integration settings and project permissions.',
  ERROR_UNKNOWN: 'Unknown error',
  ERROR_ALL_SUBTASKS_FAILED: 'Failed to create all subtasks. Please check the console for details.',
  ERROR_PARTIAL_SUBTASKS_FAILED: (succeeded: number, total: number) =>
    `Successfully created ${succeeded} out of ${total} subtasks. Some subtasks failed to create. Please check the console for details.`,
} as const
